module.exports = __webpack_public_path__ + "img/LsgOhr1-6.b4b05972.jpeg";